import React, { Component, Fragment } from 'react';

import Mobile from './Mobile/Duties';
import Desktop from './Desktop/Desktop';

import app from '../../assets/icons/app.png';
import up from '../../assets/icons/up.svg';
import search from '../../assets/icons/search.svg';
import pay from '../../assets/icons/pay.svg';
import buy from '../../assets/icons/buy.svg';
import reading from '../../assets/icons/reading.svg';
import call from '../../assets/icons/call.svg';
import down from '../../assets/icons/down.svg';

const DefaultLocation = { lat: 35.67824902764003, lng: 51.39402077611471 };
const DefaultZoom = 6;
export default class Duties extends Component {
  constructor(props) {
    super(props);
    this.state = {
      defaultLocation: DefaultLocation,
      zoom: DefaultZoom,
      location: this.defaultLocation,
      float: false,
      tag: null,
      title: null,
      orders: [
        { name: 'ملاقات', icon: app, color: '#73B4F1' },
        { name: 'پرداخت', icon: pay, color: '#62C996' },
        { name: 'بررسی', icon: search, color: '#967BE1' },
        { name: 'خرید کن', icon: buy, color: '#818AEF' },
        { name: 'ارسال', icon: up, color: '#FF6F00' },
        { name: 'مطالعه', icon: reading, color: '#00838F' },
        { name: 'تماس بگیر', icon: call, color: '#00838F' },
        { name: 'دریافت', icon: down, color: '#67EF9E' }
      ],
      repeat: false,
      repeats: [
        { id: 0, name: 'هر روز', checked: true, },
        { id: 1, name: 'هر هفته', checked: false },
        { id: 2, name: 'هر ماه', checked: false },
        { id: 3, name: 'هر سال', checked: false },
      ],
      alarm: false,
      alarms: [
        { id: 0, name: 'همان لحظه', checked: true, },
        { id: 1, name: '15 دقیقه ', checked: false, },
        { id: 2, name: '30 دقیقه ', checked: false, },
        { id: 3, name: '1 ساعت ', checked: false, },
        { id: 4, name: '2 ساعت ', checked: false, },
        { id: 5, name: 'یک روز ', checked: false, },
      ],
      selectedDay: null,
      selectedAlarm: null,
      selectedColor: null,
      selectedRepeat: 'هر روز',
      note: null,
      openCalendar: false,
      colors: [
        { id: 0, color: '#73B4F1', checked: true, },
        { id: 1, color: '#5CF9BF', checked: false, },
        { id: 2, color: '#E8F533', checked: false, },
        { id: 3, color: '#FF4040', checked: false, },
        { id: 4, color: '#BA5CF9', checked: false, },
        { id: 5, color: '#5CF9C5', checked: false, },
        { id: 6, color: '#9FFF22', checked: false, },
        { id: 7, color: '#A6FF93', checked: false, },
        { id: 8, color: '#73B4F1', checked: false, },
        { id: 9, color: '#5CF9BF', checked: false, },
      ]
    }
  }

  setSelectedDay = () => {

  }

  handleChangeLocation = (lat, lng) => {
    this.setState({
      location: { lat, lng }
    })
  }

  handleChangeZoom = newZoom => {
    this.setState({
      zoom: newZoom,
    })
  }

  openFloat = () => {
    if (!this.state.tag) {
      this.setState({
        float: true,
        repeat: false,
        alarm: false,
      })
    } else {
      return;
    }
  }

  setOpenCalendar = () => {
    this.setState({
      openCalendar: !this.state.openCalendar,
      repeat: false,
      alarm: false,
    })
  }

  closeFloat = () => {
    this.setState({
      float: false,
    })
  }

  setColor = (val, id) => {
    this.setState(prevState => ({
      selectedColor: val,
      colors: prevState.colors.map(color => color.id === id ? { ...color, checked: true, } : { ...color, checked: false, }),
    }))
  }

  setOpenAlarm = () => {
    console.log('on');
    this.setState({
      alarm: !this.state.alarm,
      repeat: false,
    })
  }

  closeAlarm = (name, id) => {
    setTimeout(() => {
      this.setState(prevState => ({
        selectedAlarm: name,
        alarms: prevState.alarms.map(alarm => alarm.id === id ? { ...alarm, checked: true, } : { ...alarm, checked: false, }),
      }))
      if (window.innerWidth < 900) {
        this.setState({
          alarm: false,
        })
      }
    }, 300)
  }

  setTag = (val) => {
    this.setState({
      tag: val,
    })
    setTimeout(() => {
      this.setState({
        float: false
      })
    }, 500)
  }

  fillTitle = (val) => {
    this.setState({
      title: this.state.tag + val,
    })
  }

  deleteTag = () => {
    this.setState({
      tag: null,
      float: true,
    })
  }

  openRepeat = () => {
    this.setState({
      repeat: !this.state.repeat,
      alarm: false,
    })
  }

  closeRepeat = (name, id) => {
    setTimeout(() => {
      this.setState({
        selectedRepeat: name,
        repeats: this.state.repeats.map(repeat => repeat.id === id ? { ...repeat, checked: true, } : { ...repeat, checked: false, }),
      })
      if (window.innerWidth < 900) {
        this.setState({
          repeat: false,
        })
      }
    }, 300)
  }
  render() {
    const {
      defaultLocation,
      zoom,
      location,
      float,
      tag,
      title,
      orders,
      repeat,
      repeats,
      alarm,
      alarms,
      selectedDay,
      selectedAlarm,
      selectedColor,
      selectedRepeat,
      note,
      openCalendar,
      colors } = this.state;
    let duties;
    if (window.innerWidth > 900) {
      duties = <Desktop
        defaultLocation={defaultLocation}
        zoom={zoom}
        location={location}
        float={float}
        tag={tag}
        title={title}
        orders={orders}
        repeat={repeat}
        repeats={repeats}
        alarm={alarm}
        alarms={alarms}
        selectedDay={selectedDay}
        selectedAlarm={selectedAlarm}
        selectedColor={selectedColor}
        selectedRepeat={selectedRepeat}
        note={note}
        openCalendar={openCalendar}
        colors={colors}
        setOpenCalendar={this.setOpenCalendar}
        openEvents={this.openEvents}
        openFloat={this.openFloat}
        openRepeat={this.openRepeat}
        closeFloat={this.closeFloat}
        closeRepeat={this.closeRepeat}
        setSelectedDay={this.setSelectedDay}
        setColor={this.setColor}
        fillTitle={this.fillTitle}
        setTag={this.setTag}
        deleteTag={this.deleteTag}
        handleChangeZoom={this.handleChangeZoom}
        handleChange={this.handleChange}
        closeAlarm={this.closeAlarm}
        setOpenAlarm={this.setOpenAlarm}
      />;
    }
    else if (window.innerWidth < 900) {
      duties = <Mobile
        defaultLocation={defaultLocation}
        zoom={zoom}
        location={location}
        float={float}
        tag={tag}
        title={title}
        orders={orders}
        repeat={repeat}
        repeats={repeats}
        alarm={alarm}
        alarms={alarms}
        selectedDay={selectedDay}
        selectedAlarm={selectedAlarm}
        selectedColor={selectedColor}
        selectedRepeat={selectedRepeat}
        note={note}
        openCalendar={openCalendar}
        colors={colors}
        setOpenCalendar={this.setOpenCalendar}
        openEvents={this.openEvents}
        openFloat={this.openFloat}
        openRepeat={this.openRepeat}
        closeFloat={this.closeFloat}
        closeRepeat={this.closeRepeat}
        setSelectedDay={this.setSelectedDay}
        setColor={this.setColor}
        fillTitle={this.fillTitle}
        setTag={this.setTag}
        deleteTag={this.deleteTag}
        handleChangeZoom={this.handleChangeZoom}
        handleChange={this.handleChange}
        closeAlarm={this.closeAlarm}
        setOpenAlarm={this.setOpenAlarm}
      />;
    }
    return (
      <Fragment>
        { duties}
      </Fragment >
    );
  }
}